var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',{staticClass:"main"},[_c('el-aside',{attrs:{"width":"200px"}},[_c('MainMenu')],1),_vm._v(" "),_c('el-main',[_c('div',{staticClass:"main-content"},[_c('MainHeader'),_vm._v(" "),(_vm.$route.path !== '/')?_c('page-header',{attrs:{"title":this.$route.meta.title}}):_vm._e(),_vm._v(" "),_c('router-view',{staticClass:"main-body"})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56e77d82","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Main/index.vue
// module id = null
// module chunks = 